import React, { useState, useEffect } from "react";
import { Sidebar, Menu, Divider } from "semantic-ui-react";
import ItemCart from "./ItemCart";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { styles } from "./styles/styles";
import {
  formatCurrency,
  formatterUSD,
} from "../../commons/functions/generalFunctions";
import { daysRestriction } from "./../../commons/helpers/daysRestriction";

const SideBarCart = (props) => {
  const { setNProducts, currencySelect } = props;
  setNProducts(props.cart.cart.length);
  const [currencyValue, SetCurrencyValue] = useState(0);
  const cartItems = props.cart.cart.sort((a, b) => {
    return b.cartPosition - a.cartPosition;
  });

  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      SetCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      SetCurrencyValue(0);
    }
  }, [currencySelect]);

  let subtotal = 0;
  let price = 0;
  if (props.cart && props.cart.cart) {
    props.cart.cart.forEach((item) => {
      currencyValue === 0
        ? (price = item.price)
        : (price = Math.ceil(item.price / currencyValue.data.value) - 0.01);
      subtotal = subtotal + price * item.quantity;
    });
  }
  return (
    <>
      <Sidebar
        as={Menu}
        animation="overlay"
        direction="right"
        icon="labeled"
        inverted
        vertical
        visible={props.opened}
        style={styles.containerSideBar}
      >
        <div className="d-flex flex-row justify-content-between pl-4 pr-4">
          <p style={styles.titleHeader} className="mt-4">
            CANASTA
          </p>
          <button
            type="button"
            className="btn btn-link text-dark"
            onClick={() => props.setOpened(false)}
          >
            <p style={styles.titleHeader}>X</p>
          </button>
        </div>
        {false && (
          <div className="pl-4 pb-2 pt-2" style={styles.containerPromo}>
            <p className="text-left text-muted">
              Gaste L.100 más y obtenga envío gratis
            </p>
          </div>
        )}
        <div
          hidden={props.cart && props.cart.cart.length > 0 ? false : true}
          style={styles.containerItemsCart}
        >
          {props.cart.cart
            ? cartItems.map((product) => (
                <ItemCart key={product.id} {...product} />
              ))
            : null}
        </div>
        <div
          hidden={props.cart && props.cart.cart.length > 0 ? true : false}
          style={styles.cartEmpty}
        >
          {props.cart && props.cart.cart.length > 0 ? (
            false
          ) : (
            <h6>Su carrito está vacío</h6>
          )}
        </div>
        <div
          hidden={props.cart && props.cart.cart.length > 0 ? false : true}
          className="pt-2 mt-2 text-left pl-4 pr-4"
          style={styles.containerTop}
        >
          <p style={styles.sentTitle}>Gastos de envío calculados en la caja</p>
          <div style={styles.divSubTot}>
            <span style={styles.spanSubTot}>
              <h2 style={styles.h2SubTot}>Subtotal:</h2>
              <div style={styles.divPrice}>
                {currencySelect.loading
                  ? "Cargando..."
                  : currencyValue === 0
                  ? formatCurrency(Math.ceil(subtotal))
                  : formatterUSD.format(subtotal)}
              </div>
              <Divider />
            </span>
          </div>
          {!daysRestriction() && (
            <div className="w-100 text-center">
              <Link
                className="btn btn-dark"
                to="/checkout"
                onClick={() => props.setOpened(false)}
              >
                Comprar ahora
              </Link>
            </div>
          )}
        </div>
      </Sidebar>
    </>
  );
};

const mapStateToProps = (state) => {
  return { cart: state.cart, currencySelect: state.currencySelect };
};

export default connect(mapStateToProps)(SideBarCart);
